// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"292":"StockOrders","810":"NotFound","857":"StockPurchaseOrders"}[chunkId] + "." + {"292":"bfb4cf07","810":"7874db63","857":"bfb4cf07"}[chunkId] + ".css";
};